import React, { useState, useRef, useEffect } from 'react';
import './Filters.css';
import Select from '../Select/Select';
import Input from '../Input/Input';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { formatDate } from '../../utils/utils';
//icons
import clearIcon from '../../assets/clearIcon.png';

const Filters = ({ filters, onApplyFilters }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedFilters, setSelectedFilters] = useState({});
  const [activeFilters, setActiveFilters] = useState([]);
  const [openFilterIds, setOpenFilterIds] = useState([]);
  // const [dateRange, setDateRange] = useState([null, null]);
  // const [startDate, endDate] = dateRange;
  const wrapperRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleFilterChange = (filterId, value) => {
    console.log("handleFilterChange: ",filterId, value);
    setSelectedFilters(prev => ({
      ...prev,
      [filterId]: value
    }));
  };

  const handleApplyFilters = () => {
    const processedFilters = {};
    const newActiveFilters = [];

    // Crear un mapa para agrupar los rangos numéricos
    const numberRanges = {};

    Object.entries(selectedFilters).forEach(([key, value]) => {
      if (value === '' || value === null || (Array.isArray(value) && value.length === 0)) return;

      // Manejar filtros de rango de fecha
      // dateRange: claves *_start / *_end ya vienen cargadas desde render
      if (key.endsWith('_start') || key.endsWith('_end')) {
        const baseId = key.replace('_start', '').replace('_end', '');
        const filter = filters.find(f => f.id === baseId);
        if (!filter) return;
        if (!processedFilters[baseId]) processedFilters[baseId] = {};
        if (key.endsWith('_start')) processedFilters[baseId].start_date = value;
        else processedFilters[baseId].end_date = value;
        // Solo agregar al activeFilters cuando tengamos ambas fechas
        if (processedFilters[baseId].start_date && processedFilters[baseId].end_date) {
          newActiveFilters.push({
            id: baseId,
            label: filter.label,
            value: `${formatDate(new Date(processedFilters[baseId].start_date))} - ${formatDate(new Date(processedFilters[baseId].end_date))}`
          });
        }
      } 
      // Manejar filtros de rango numérico
      else if (key.endsWith('_min') || key.endsWith('_max')) {
        const baseId = key.replace('_min', '').replace('_max', '');
        const filter = filters.find(f => f.id === baseId);
        if (!filter) return;

        // Inicializar el objeto para este rango si no existe
        if (!numberRanges[baseId]) {
          numberRanges[baseId] = {
            filter: filter,
            min: null,
            max: null
          };
        }

        // Almacenar el valor min o max
        if (key.endsWith('_min')) {
          numberRanges[baseId].min = value;
          processedFilters[`${baseId}_min`] = value;
        } else {
          numberRanges[baseId].max = value;
          processedFilters[`${baseId}_max`] = value;
        }
      } 
      else {
        // Manejar otros tipos de filtros
        const filter = filters.find(f => f.id === key);
        if (!filter) return;

        // multi-select años
        if (filter.type === 'multi-select' && Array.isArray(value)) {
          processedFilters[key] = value;
          const label = filter.label;
          const display = value
            .map(v => (typeof v === 'object' ? v.label ?? v.value : v))
            .join(', ');
          newActiveFilters.push({ id: key, label, value: display });
        } else {
          // Otros tipos
          processedFilters[key] = value;
          newActiveFilters.push({
            id: key,
            label: filter.label,
            value: Array.isArray(value)
              ? value.join(', ')
              : (typeof value === 'object' ? (value.label ?? value.value) : value)
          });
        }
      }
    });

    // Procesar los rangos numéricos para activeFilters
    Object.entries(numberRanges).forEach(([baseId, rangeData]) => {
      const { filter, min, max } = rangeData;
      
      if (min !== null || max !== null) {
        newActiveFilters.push({
          id: baseId,
          label: filter.label,
          value: `${min || '0'} - ${max || '∞'}`
        });
      }
    });

    setActiveFilters(newActiveFilters);
    onApplyFilters(processedFilters);
    setIsOpen(false);
  };

  const removeFilter = (filterId) => {
    const newSelectedFilters = { ...selectedFilters };
    
    // Si es un filtro de rango de fecha, eliminar ambos valores
    const filter = filters.find(f => f.id === filterId);
    if (filter && filter.type === 'dateRange') {
      delete newSelectedFilters[`${filterId}_start`];
      delete newSelectedFilters[`${filterId}_end`];
    } 
    // Si es un filtro de rango numérico, eliminar valores min y max
    else if (filter && filter.type === 'number-range') {
      delete newSelectedFilters[`${filterId}_min`];
      delete newSelectedFilters[`${filterId}_max`];
    } else {
      delete newSelectedFilters[filterId];
    }
    
    setSelectedFilters(newSelectedFilters);
    setActiveFilters(activeFilters.filter(f => f.id !== filterId));
    onApplyFilters(newSelectedFilters);
  };

  const removeAllFilters = () => {
    setSelectedFilters({});
    setActiveFilters([]);
    onApplyFilters({});
  };

  const renderFilterInput = (filter) => {
    switch (filter.type) {
      case 'dropdown':
        return (
          <Select
            placeholder={filter.label}
            options={filter.options}
            value={selectedFilters[filter.id] || ''}
            onChange={({ target: { value } }) => {
              console.log("onChange: ",filter.id, value);
              handleFilterChange(filter.id, value)
            }}
            isClearable
            size="small"
          />
        );
      case 'text':
        return (
          <Input
            label={filter.label}
            placeholder={filter.placeholder}
            value={selectedFilters[filter.id] || ''}
            onChange={(e) => {
              console.log("onChange: ",filter.id, e.target.value);
              handleFilterChange(filter.id, e.target.value)
            }}
          />
        );
      case 'number':
        return (
          <Input
            type="number"
            label={filter.label}
            placeholder={filter.placeholder}
            value={selectedFilters[filter.id] || ''}
            onChange={(e) => handleFilterChange(filter.id, e.target.value)}
          />
        );
      case 'number-range':
        return (
          <div className="filter-number-range">
            <Input
              type="number"
              size="small"
              label={filter.label}
              placeholder={filter.placeholder}
              value={selectedFilters[`${filter.id}_min`] || ''}
              onChange={(e) => handleFilterChange(`${filter.id}_min`, e.target.value)}
            />
            <span>-</span>
            <Input
              type="number"
              size="small"
              label={filter.label}
              placeholder={filter.placeholder2}
              value={selectedFilters[`${filter.id}_max`] || ''}
              onChange={(e) => handleFilterChange(`${filter.id}_max`, e.target.value)}
            />
          </div>
        );
      case 'checkbox':
        return (
          <div className="filter-checkbox">
            <div className="checkbox-options">
              {filter.options.map(option => (
                <div key={option} className="checkbox-container">
                  <input
                    type="radio"
                    name={filter.id}
                    checked={selectedFilters[filter.id] === option}
                    onChange={() => handleFilterChange(filter.id, option)}
                  />
                  <span>{option}</span>
                </div>
              ))}
            </div>
          </div>
        );
      case 'multi-select':
        // Implementación simple con checkboxes múltiples
        return (
          <div className="filter-checkbox">
            <div className="checkbox-options">
              {(filter.options || []).map((opt) => {
                const current = Array.isArray(selectedFilters[filter.id]) ? selectedFilters[filter.id] : [];
                const isChecked = current.some(v => (typeof v === 'object' ? v.value : v) === (opt.value ?? opt));
                return (
                  <label key={opt.value ?? opt} className="checkbox-container">
                    <input
                      type="checkbox"
                      checked={isChecked}
                      onChange={(e) => {
                        if (e.target.checked) {
                          handleFilterChange(filter.id, [...current, opt]);
                        } else {
                          handleFilterChange(
                            filter.id,
                            current.filter(v => (typeof v === 'object' ? v.value : v) !== (opt.value ?? opt))
                          );
                        }
                      }}
                    />
                    <span>{opt.label ?? opt}</span>
                  </label>
                );
              })}
            </div>
          </div>
        );
      case 'date':
        return (
          <div className="datepicker-container">
            <DatePicker
              selected={selectedFilters[filter.id] ? new Date(selectedFilters[filter.id]) : null}
              onChange={(date) => handleFilterChange(filter.id, date ? date.toISOString() : null)}
              dateFormat="dd/MM/yyyy"
              placeholderText={filter.placeholder}
              isClearable
              showYearDropdown
              scrollableYearDropdown
              className="datepicker-input"
            />
          </div>
        );
      case 'dateRange':
        return (
          <div className="datepicker-container">
            <DatePicker
              selectsRange
              startDate={selectedFilters[`${filter.id}_start`] ? new Date(selectedFilters[`${filter.id}_start`]) : null}
              endDate={selectedFilters[`${filter.id}_end`] ? new Date(selectedFilters[`${filter.id}_end`]) : null}
              onChange={(update) => {
                const [s, e] = update;
                handleFilterChange(`${filter.id}_start`, s ? s.toISOString() : null);
                handleFilterChange(`${filter.id}_end`, e ? e.toISOString() : null);
              }}
              dateFormat="dd/MM/yyyy"
              placeholderText={filter.placeholder}
              isClearable
              showYearDropdown
              scrollableYearDropdown
              className="datepicker-input"
            />
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div className="filters-wrapper" ref={wrapperRef}>
      <div className="filters-header" onClick={() => setIsOpen(!isOpen)}>
        <span>Filters</span>
        <span className={`arrow ${isOpen ? 'open' : ''}`}>›</span>
      </div>

      {isOpen && (
        <div className="filters-content">
          <div className="filters-list">
            {filters.map(filter => (
              <div key={filter.id} className="filter-item">
                <div 
                  className="filter-header" 
                  onClick={() => {
                    setOpenFilterIds(prev => 
                      prev.includes(filter.id)
                        ? prev.filter(id => id !== filter.id)
                        : [...prev, filter.id]
                    );
                  }}
                >
                  <span className={`arrow ${openFilterIds.includes(filter.id) ? 'open' : ''}`}>›</span>
                  {filter.label}
                </div>
                {openFilterIds.includes(filter.id) && (
                  <div className="filter-input">
                    {renderFilterInput(filter)}
                  </div>
                )}
              </div>
            ))}
          </div>
          <div className="filters-actions">
            <button className="apply-filters" onClick={handleApplyFilters}>
              Apply Filters
            </button>
          </div>
        </div>
      )}

      {activeFilters.length > 0 && (
        <div className="active-filters">
          <button className="clear-filters" onClick={removeAllFilters}>
            <img src={clearIcon} alt="Clear" className="clear-icon" />
          </button>
          {activeFilters.map(filter => (
            <div key={filter.id} className="filter-tag">
              <span>{filter.label}: {filter.value}</span>
              <button onClick={() => removeFilter(filter.id)}>×</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Filters;
